import LiveGameSection from '../../components/MyAccount/Sections/LiveGameSection/LiveGameSection'
import SocketProvider from '../../context/socket'

const LiveGamePage = () => {
  return (
    <main className={`container`}>
      <SocketProvider namespace={"/liveGame"}>
        <LiveGameSection />
      </SocketProvider>
    </main>
  )
}

export default LiveGamePage